import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContentDetailPage from "./pages/ContentDetailPage";
import ConoceBravoPage from "./pages/ConoceBravoPage";
import DispositivoBravoPage from "./pages/DispositivoBravoPage";
import CatalogPage from "./pages/CatalogPage";
import PastEventsPage from "./pages/PastEventsPage";
import CalendarPage from "./pages/CalendarPage";
import ContractTermsPage from "./pages/ContractTermsPage";
import SobreNosotrosPage from "./pages/SobreNosotrosPage";
import FAQPage from "./pages/FAQPage";
import ColaboraPage from "./pages/ColaboraPage";
import AvisoLegalPage from "./pages/AvisoLegalPage";
import PoliticaCookiesPage from "./pages/PoliticaCookiesPage";
import PoliticaPrivacidadPage from "./pages/PoliticaPrivacidadPage";
import CinemaRegisterPage from "./pages/CinemaRegisterPage";
import CinemaLoginPage from "./pages/CinemaLoginPage";
import CinemaResetPasswordPage from "./pages/CinemaResetPasswordPage";
import CinemaBookingPage from "./pages/CinemaBookingPage";
import CinemaPortalPage from "./pages/CinemaPortalPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import BravoSupportChat from "./pages/BravoSupportChat";
import TurandotInscripcionesPage from "./pages/TurandotInscripcionesPage";
import DistribucionDCPPage from "./pages/DistribucionDCPPage";
import CookieBanner from "./components/CookieBanner";
import AnalyticsTracker from "./components/AnalyticsTracker";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/content/:id" element={<ContentDetailPage />} />
          <Route path="/conoce-bravo" element={<ConoceBravoPage />} />
          <Route path="/dispositivo-bravo" element={<DispositivoBravoPage />} />
          <Route path="/dispositivo-bravo-dcp" element={<DistribucionDCPPage />} />
          <Route path="/catalogo" element={<CatalogPage />} />
          <Route path="/eventos-pasados" element={<PastEventsPage />} />
          <Route path="/calendario" element={<CalendarPage />} />
          <Route path="/condiciones" element={<ContractTermsPage />} />
          <Route path="/sobre-nosotros" element={<SobreNosotrosPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/colabora" element={<ColaboraPage />} />
          
          {/* Turandot Special Page */}
          <Route path="/turandot-inscripciones" element={<TurandotInscripcionesPage />} />
          
          {/* Legal Pages */}
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-cookies" element={<PoliticaCookiesPage />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
          
          {/* Cinema Routes */}
          <Route path="/cinema" element={<Navigate to="/cinema/booking" replace />} />
          <Route path="/cinema/register" element={<CinemaRegisterPage />} />
          <Route path="/cinema/login" element={<CinemaLoginPage />} />
          <Route path="/cinema/reset-password" element={<CinemaResetPasswordPage />} />
          <Route path="/cinema/portal" element={<CinemaBookingPage />} />
          <Route path="/cinema/booking" element={<CinemaBookingPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* Support Chat (hidden) */}
          <Route path="/chat-soporte" element={<BravoSupportChat />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
